// "Gifts" tab.
import type { ReactNode } from 'react';
import { TabPlaceholder } from './TabPlaceholder.js';

export function Gifts(): ReactNode {
  return (
    <TabPlaceholder
      tabName="Gifts"
      wiringNotes="Composes a gift-with-purchase draft order and tags the customer for gift eligibility via SHOPIFY_TAG_CUSTOMER. First-sub GWP program is inactive (memory: project_100x_equine_first_sub_gwp)."
    />
  );
}
